import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Status } from '../../common/constants';
import { registerOrgUrl } from '../../config';
import { RootState } from '../../store';
import axios from 'axios';

export interface IEnrollOrganizationData {
  name: string;
  email: string;
  phoneNo: string;
  address: string;
  adminName: string;
  orgId?: string;
  isPasswordEnable?: boolean;
  password?: string;
}

interface IInitialState {
  organizationDetails: IEnrollOrganizationData;
  status: string;
  error: string | null;
  queryParam: string | null;
}

const initialState: IInitialState = {
  organizationDetails: null,
  status: Status.IDLE,
  error: null,
  queryParam: null,
};

export const enrollOrganization: any = createAsyncThunk(
  'enrollOrganization',
  async (
    userDetails: IEnrollOrganizationData,
    { getState, rejectWithValue }
  ) => {
    const state = getState() as RootState;
    const authToken = state.enrollOrganizationApi.queryParam;
    try {
      const data = {
        displayName: userDetails.name,
        email: userDetails.email,
        phoneNo: userDetails.phoneNo,
        address: userDetails.address,
        name: userDetails.adminName,
        isPasswordEnable: userDetails.isPasswordEnable,
        password: userDetails.password
      };
      const response = await axios.put(registerOrgUrl, data, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      });
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

const enrollOrganizationSlice = createSlice({
  name: 'enrollOrganization',
  initialState: initialState,
  reducers: {
    updateQueryParams(state, action) {
      state.queryParam = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(enrollOrganization.pending, (state) => {
        state.status = Status.PENDING;
      })
      .addCase(enrollOrganization.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.organizationDetails = action.payload;
      })
      .addCase(enrollOrganization.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error =
          action.payload?.message || 'Failed to enroll organization';
      });
  },
});

export const selector = (state: RootState) => state.enrollOrganizationApi;
export const { updateQueryParams } = enrollOrganizationSlice.actions;
export default enrollOrganizationSlice.reducer;
